import React from 'react';
import { IconButton } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

class ShareIconButtonn extends React.Component {
  render() {
    const { className, style, ariaLabel, handleClick } = this.props;
    return (
      <IconButton
        aria-label={ariaLabel ? ariaLabel : 'Share'}
        color="primary"
        className={className}
        style={style}
        onClick={handleClick}
        size="large">
        <ShareIcon />
      </IconButton>
    );
  }
}

export default ShareIconButtonn;
